import SelectBox from "devextreme-react/select-box";
import React, { useEffect, useState } from "react";
import { hinhThucThanhToanApi } from "../../api/hinhThucThanhToanApi";
import { useCommonContext } from "../../contexts/common";
import { sf_hinhthucthanhtoan } from "../../models/response/hinh-thuc-thanh-toan/sf_hinhthucthanhtoan";
type ICmbHinhThucThanhToanProps = {
    isReadonly?: boolean,
    value?: number,
    width?: number,
    onValueChanged: (id: number, data?: sf_hinhthucthanhtoan) => void,
    className?: string,
    isShowClearButton?: boolean,
    preText?: string,
    stylingMode?: "outlined" | "filled" | "underlined",
    dmCoSoId?: number
}
const CmbHinhThucThanhToan = (props: ICmbHinhThucThanhToanProps) => {
    const [hinhThucThanhToans, setHinhThucThanhToans] = useState<sf_hinhthucthanhtoan[]>([]);
    useEffect(() => {
        handleReloadHinhThucThanhToans();
    }, [props.dmCoSoId])
    const handleReloadHinhThucThanhToans = async () => {
        const res = await hinhThucThanhToanApi.select_all();
        if (res.is_success) {
            setHinhThucThanhToans(res.data.filter((x: any) => x.dm_coso_id === props.dmCoSoId))
        }
    }
    const { translate } = useCommonContext();
    return (
        <SelectBox dataSource={hinhThucThanhToans}
            displayExpr={"hinh_thuc_thanh_toan"}
            valueExpr={"id"}
            value={props.value}
            stylingMode={props.stylingMode || "outlined"}
            readOnly={props.isReadonly === true}
            placeholder={translate("Chọn hình thức thanh toán")}
            width={props.width ?? "100%"}
            className={"default_selectbox " + (props.className ? props.className : "")}
            showClearButton={props.isShowClearButton === true}
            onValueChanged={(e) => {
                if (e.event) {
                    const data = hinhThucThanhToans.find(x => x.id == e.value)
                    props.onValueChanged(e.value, data)
                }
            }} />
    );
}
export default CmbHinhThucThanhToan

